import { useState } from 'react';
import { defaultFilters } from '../utils/invoiceConstants';

export const useInvoiceState = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalInvoices, setTotalInvoices] = useState(0);
  const [filters, setFilters] = useState(defaultFilters);
  const [showFilters, setShowFilters] = useState(false);
  const [importing, setImporting] = useState(false);
  const [importProgress, setImportProgress] = useState({ current: 0, total: 0 });
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [isQbConnected, setIsQbConnected] = useState(false);
  const [hasNewRecords, setHasNewRecords] = useState(false);
  const [isOnFirstPage, setIsOnFirstPage] = useState(true);

  return {
    invoices,
    setInvoices,
    loading,
    setLoading,
    error,
    setError,
    searchTerm,
    setSearchTerm,
    currentPage,
    setCurrentPage,
    totalPages,
    setTotalPages,
    totalInvoices,
    setTotalInvoices,
    filters,
    setFilters,
    showFilters,
    setShowFilters,
    importing,
    setImporting,
    importProgress,
    setImportProgress,
    selectedInvoice,
    setSelectedInvoice,
    showInvoiceForm,
    setShowInvoiceForm,
    editingInvoice,
    setEditingInvoice,
    isQbConnected,
    setIsQbConnected,
    hasNewRecords,
    setHasNewRecords,
    isOnFirstPage,
    setIsOnFirstPage
  };
};